export const adaptValidarInsumoDetalle = (insumo) => {
    return {
        idInsumoN: insumo?.insumo?.idInsumoN,
        idInsumo: insumo?.insumo?.idInsumo,
        descripcion: insumo?.insumo?.descripcion,
        descripcionGenerica: insumo?.insumo?.descripcionGenerica,
        presentacionGenerica: insumo?.insumo?.presentacionGenerica,
        presentacion: insumo?.insumo?.presentacion,
        activo: insumo?.insumo?.activo,
        validado: insumo?.insumo?.validado,
        esSap: insumo?.insumo?.esSap,
        cantidadDias: insumo?.insumo?.cantxDia,
        cantxPack: insumo?.insumo?.cantxPack,
        eleccion: insumo?.insumo?.eleccion,
        pesoUnitario: insumo?.insumo?.pesoUnitario,
        motivoValidacion: insumo?.insumo?.motivoValidacion,
        franjaEtarea: insumo?.insumo?.idFranjaEtareaNavigation?.descripcion, 
        fabricante: insumo?.insumo?.idFabricanteNavigation?.descripcion,
        idTipoInsumo: insumo?.insumo?.idTipoInsumoNavigation.idTipoInsumo,
        tipoInsumo: insumo?.insumo?.idTipoInsumoNavigation?.descripcion,
        unidad: insumo?.insumo?.idUnidadNavigation?.descripcion,
        fraccionable: insumo?.insumo?.fraccionable,
        calorias: insumo?.insumo?.calorias,
        proteinas: insumo?.insumo?.proteinas,
        alergias: insumo?.insumo?.idAlergia?.map((alergia) => { return { descripcion: alergia.descripcion } }), 
        compatibilidades: insumo?.insumo?.idInsumoComp?.map((comp) => { return { idInsumo: comp.idInsumo, descripcion: comp.descripcion } }),
        programas: insumo?.insumoPrograma?.map((comp) => { return { descripcion: comp.idModuloTipoNavigation.abreviacion + " - " +  comp.idModuloTipoNavigation.descripcion} }),
        insumoTipoAccesos: insumo?.insumoTipoAccesos?.map((tipo) => { return { nombre: tipo.nombre } }), 
        insumoTM: insumo?.insumoProductoTM?.map((tm) => { return { idInsumo: tm.idInsumo, descripcion: tm.descripcion } }),       
        insumoCajas: insumo?.insumoCajas?.map((caja) => { return { cantidad: caja.cantidad, idInsumo: caja.idInsumoCajaNavigation.idInsumo, descripcion: caja.idInsumoCajaNavigation.descripcion } }),       
    }
}